(function() {
  'use strict';

  function initBranchLocator() {
    // Handle province button clicks
    const provinceButtons = document.querySelectorAll('.branch-locator-modal__province-button');
    provinceButtons.forEach((button) => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      
      button.addEventListener('click', (e) => {
        const sectionId = button.getAttribute('data-section-id');
        const provinceName = button.getAttribute('data-province-name') || button.textContent.trim();
        
        // Find the list modal - it should be a sibling or parent modal-dialog
        const listModal = button.closest('modal-dialog') || 
          document.querySelector(`#BranchLocatorModal-${sectionId}`) ||
          document.querySelector(`#ProductBranchLocatorModal-${sectionId}`) ||
          document.querySelector(`#FooterContactModal-${sectionId.replace('footer-', '')}`) ||
          document.querySelector(`#ContactBlockModal-${sectionId}`);
        
        // Find branch details modal by province name - search all branch detail modals
        const allBranchModals = document.querySelectorAll('.branch-details-modal[data-province-name]');
        let foundModal = null;
        
        allBranchModals.forEach((modal) => {
          const modalProvinceName = modal.getAttribute('data-province-name');
          // Check if modal belongs to the same section (check if section ID is in modal ID)
          const modalId = modal.getAttribute('id') || '';
          if (modalProvinceName === provinceName && (modalId.includes(sectionId) || modalId.includes(sectionId.replace('product-', '').replace('footer-', '')))) {
            foundModal = modal;
          }
        });
        
        if (foundModal && listModal) {
          // Show new modal first, then hide old one after it's fully visible
          foundModal.show(button);
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              listModal.hide();
            });
          });
        }
      });
    });

    // Handle back button clicks
    const backButtons = document.querySelectorAll('.branch-details-modal__back');
    backButtons.forEach((button) => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      
      button.addEventListener('click', (e) => {
        const backToModal = button.getAttribute('data-back-to-list');
        const currentModal = button.closest('modal-dialog');
        const targetModal = document.querySelector(backToModal);
        
        if (currentModal && targetModal) {
          // Show new modal first, then hide old one after it's fully visible
          targetModal.show(button);
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              currentModal.hide();
            });
          });
        }
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBranchLocator);
  } else {
    initBranchLocator();
  }

  // Re-initialize when new sections are loaded (for theme editor)
  document.addEventListener('shopify:section:load', initBranchLocator);
})();

